export const IS_DETAILS_READY = 'QUESTION_MODEL/DETAILS/READY';

export const FETCH_QUESTION_MODELS = 'QUESTION_MODEL/QUESTIONS/FETCH_REQUEST';
export const FETCH_QUESTION_MODELS_SUCCESS = 'QUESTION_MODEL/QUESTIONS/FETCH_SUCCESS';
export const FETCH_QUESTION_MODELS_FAILURE = 'QUESTION_MODEL/QUESTIONS/FETCH_FAILURE';

export const FETCH_QUESTION_MODEL = 'QUESTION_MODEL/FETCH/REQUEST';
export const FETCH_QUESTION_MODEL_SUCCESS = 'QUESTION_MODEL/FETCH/SUCCESS';
export const FETCH_QUESTION_MODEL_FAILURE = 'QUESTION_MODEL/FETCH/FAILURE';

export const SELECT_QUESTION_MODEL = 'QUESTION_MODEL/SELECT';
export const SET_SELECTED_LOCALE = 'QUESTION_MODEL/SET_SELECTED_LOCALE';

export const UPDATE_QUESTION_MODEL = 'QUESTION_MODEL/PUT/UPDATE_REQUEST';
export const UPDATE_QUESTION_MODEL_SUCCESS = 'QUESTION_MODEL/PUT/UPDATE_SUCCESS';
export const UPDATE_QUESTION_MODEL_FAILURE = 'QUESTION_MODEL/PUT/UPDATE_FAILURE';

export const CREATE_QUESTION_MODEL = 'QUESTION_MODEL/POST/CREATE_REQUEST';
export const CREATE_QUESTION_MODEL_SUCCESS = 'QUESTION_MODEL/POST/CREATE_SUCCESS';
export const CREATE_QUESTION_MODEL_FAILURE = 'QUESTION_MODEL/POST/CREATE_FAILURE';

export const DELETE_QUESTION_MODEL = 'QUESTION_MODEL/DELETE/REQUEST';
export const DELETE_QUESTION_MODEL_SUCCESS = 'QUESTION_MODEL/DELETE/SUCCESS';
export const DELETE_QUESTION_MODEL_FAILURE = 'QUESTION_MODEL/DELETE/FAILURE';

export const CLONE_QUESTION_MODEL = 'QUESTION_MODEL/POST/CLONE_REQUEST';
export const CLONE_QUESTION_MODEL_SUCCESS = 'QUESTION_MODEL/POST/CLONE_SUCCESS';
export const CLONE_QUESTION_MODEL_FAILURE = 'QUESTION_MODEL/POST/CLONE_FAILURE';

export const QUESTION_MODEL_STATISTICS_COUNT = 'QUESTION_MODEL_STATISTIC/COUNT/REQUEST';
export const QUESTION_MODEL_STATISTICS_COUNT_SUCCESS = 'QUESTION_MODEL_STATISTIC/COUNT/SUCCESS';
export const QUESTION_MODEL_STATISTICS_COUNT_FAILURE = 'QUESTION_MODEL_STATISTIC/COUNT/FAILURE';
export const SET_QUESTION_MODEL_STATISTICS_ID = 'QUESTION_MODEL_STATISTIC/ID/SET';

export const QUESTION_MODEL_STATISTICS_ANSWERS = 'QUESTION_MODEL_STATISTIC/ANSWERS/REQUEST';
export const QUESTION_MODEL_STATISTICS_ANSWERS_SUCCESS = 'QUESTION_MODEL_STATISTIC/ANSWERS/SUCCESS';

export const CLEAR_QUESTION_MODEL_STATISTIC = 'QUESTION_MODEL_STATISTIC/CLEAR';

export const ADD_FILTER_QUESTION_MODEL_STATISTIC = 'QUESTION_MODEL_STATISTIC/FILTER/ADD';
export const REMOVE_FILTER_QUESTION_MODEL_STATISTIC = 'QUESTION_MODEL_STATISTIC/FILTER/REMOVE';
export const REMOVE_ALL_FILTER_QUESTION_MODEL_STATISTIC = 'QUESTION_MODEL_STATISTIC/FILTER/REMOVE_ALL';

export const OPEN_EXPORT_STATS_MODAL = 'QUESTION_MODAL_STATISTIC/EXPORT/OPEN';
export const CLOSE_EXPORT_STATS_MODAL = 'QUESTION_MODAL_STATISTIC/EXPORT/CLOSE';

export const EXPORT_QUESTION_MODEL_STATISTIC = 'QUESTION_MODEL_STATISTIC/EXPORT';

export const FETCH_DEFAULT_QUESTION_MODEL = 'QUESTION_MODEL/FETCH/DEFAULT_REQUEST';
export const FETCH_DEFAULT_QUESTION_MODEL_SUCCESS = 'QUESTION_MODEL/FETCH/DEFAULT_SUCCESS';
export const FETCH_DEFAULT_QUESTION_MODEL_FAILURE = 'QUESTION_MODEL/FETCH/DEFAULT_FAILURE';

export const CREATE_FROM_DEFAULT_QUESTION_MODEL = 'QUESTION_MODEL/CREATE_FROM_DEFAULT_REQUEST';
